import React, { useEffect, useState, useCallback } from 'react';
import { IconClose } from '../../icons';
import FiltroListaDemandas from '../FiltroListaDemandas';
import { IFiltroListaDemandas } from '../../../types';
import {
  Container,
  SidebarContent,
  Header,
  TitleSection,
  Title,
  ButtonSection,
  ClearButton,
  CloseButton,
  Content,
  Overlay
} from './styles';

interface SidebarFiltrosProps {
  isOpen: boolean;
  onClose: () => void;
  filtros: IFiltroListaDemandas;
  onFiltrosChange: (filtros: IFiltroListaDemandas) => void;
  onLimparFiltros: () => void;
  quantidadeFiltrosAtivos?: number;
}

export default function SidebarFiltros({
  isOpen,
  onClose,
  filtros,
  onFiltrosChange,
  onLimparFiltros,
  quantidadeFiltrosAtivos = 0
}: SidebarFiltrosProps) {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Prevent body scroll when sidebar is open on mobile only
  useEffect(() => {
    if (isOpen && window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      // On desktop, don't prevent scrolling - allow normal interaction
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isOpen]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);


  const handleLimparFiltros = () => {
    onLimparFiltros();
  };

  // Handle touch gestures for mobile swipe-to-close
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isRightSwipe = distance < -50; // Swipe right threshold
    
    // Close sidebar if swiped right significantly
    if (isRightSwipe && window.innerWidth <= 768) {
      handleClose();
    }
    
    // Reset touch values
    setTouchStart(0);
    setTouchEnd(0);
  };

  return (
    <>
      <Overlay isOpen={isOpen} onClick={handleClose} />
      <Container 
        isOpen={isOpen}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <SidebarContent>
          <Header>
            <TitleSection>
              <Title>Filtros</Title>
            </TitleSection>
            <ButtonSection>
              <ClearButton onClick={handleLimparFiltros}>
                Limpar Filtros
              </ClearButton>
              <CloseButton onClick={handleClose}>
                <IconClose color="#6b7280" />
              </CloseButton>
            </ButtonSection>
          </Header>

          <Content>
            <FiltroListaDemandas
              filtros={filtros}
              atualizaFiltros={onFiltrosChange}
            />
          </Content>
        </SidebarContent>
      </Container>
    </>
  );
};

